module.exports = __webpack_public_path__ + "img/trash-can-arrow-up.616a9125.svg";